/*!
 * @license MIT
 * newrelic-google-publisher-tag 0.1.0
 * Copyright New Relic <http://newrelic.com/>
 * @author Jordi Aguilar
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nrvideo"] = factory();
	else
		root["nrvideo"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Static Log class
 *
 * @class
 * @static
 */
var Log = function () {
  function Log() {
    _classCallCheck(this, Log);
  }

  _createClass(Log, null, [{
    key: 'error',

    /**
    * Sends an error console log.
    * @param {...any} [msg] Message to show
    * @static
    */
    value: function error() {
      for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
        msg[_key] = arguments[_key];
      }

      _report(msg, Log.Levels.ERROR, 'darkred');
    }

    /**
     * Sends a warning console log.
     * @method Log.warn
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'warn',
    value: function warn() {
      for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      _report(msg, Log.Levels.WARNING, 'darkorange');
    }

    /**
     * Sends a notice console log.
     * @method Log.notice
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'notice',
    value: function notice() {
      for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      _report([].slice.call(arguments), Log.Levels.NOTICE, 'darkcyan');
    }

    /**
     * Sends a debug message to console.
     * @method Log.debug
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'debug',
    value: function debug() {
      for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      _report(msg, Log.Levels.DEBUG, 'indigo');
    }

    /**
     * This utility method will add most of the HTML5 common event listeners to the player sent.
     * Events will be reported as DEBUG level messages.
     *
     * @example
     * // Already included events:
     * ['canplay', 'buffering', 'waiting', 'ended', 'play', 'playing', 'pause', 'resume', 'error',
     * 'abort', 'seek', 'seeking', 'seeked', 'stalled', 'dispose', 'loadeddata', 'loadstart',
     * 'loadedmetadata']
     *
     * @method Log.debugCommonVideoEvents
     * @static
     * @param {object|function} o Object to attach the events.
     * @param {array} [extraEvents]
     * An array of extra events to watch. ie:  ['timeupdate', 'progress'].
     * If the first item is null, no common events will be added.
     * @param {function} [report] Callback function called to report events.
     * Default calls Log.debug()
     */

  }, {
    key: 'debugCommonVideoEvents',
    value: function debugCommonVideoEvents(o, extraEvents, report) {
      try {
        if (Log.level <= Log.Levels.DEBUG) {
          report = report || function (e) {
            Log.debug('Event: ' + e.type);
          };

          var playerEvents = ['canplay', 'buffering', 'waiting', 'ended', 'play', 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled', 'dispose', 'loadeddata', 'loadstart', 'loadedmetadata'];
          if (extraEvents) {
            if (extraEvents[0] === null) {
              extraEvents.shift();
              playerEvents = extraEvents;
            } else {
              playerEvents = playerEvents.concat(extraEvents);
            }
          }

          for (var i = 0; i < playerEvents.length; i++) {
            if (typeof o === 'function') {
              o.call(window, playerEvents[i], report);
            } else if (o.on) {
              o.on(playerEvents[i], report);
            } else if (o.addEventListener) {
              o.addEventListener(playerEvents[i], report);
            } else if (o.addEventHandler) {
              o.addEventHandler(playerEvents[i], report);
            } else {
              Log.warn('debugCommonVideoEvents: No common listener function found for ', o);
            }
          }
        }
      } catch (err) {
        Log.warn(err);
      }
    }
  }]);

  return Log;
}();

/**
 * Enum for log levels
 * @enum
 * @static
 * @var
 */


Log.Levels = {
  /** No console outputs */
  SILENT: 5,
  /** Console will show errors */
  ERROR: 4,
  /** Console will show warnings */
  WARNING: 3,
  /** Console will show notices (ie: life-cyrcle logs) */
  NOTICE: 2,
  /** Console will show debug messages. */
  DEBUG: 1,
  /** Show all messages. */
  ALL: 0

  /**
   * Only logs of this imporance or higher will be shown.
   * @example Log.level = Log.Levels.ALL
   * @default Log.Levels.ERROR
   * @static
   */
};Log.level = Log.Levels.ERROR;

/**
 * If true, logs will be outputed with colors.
 * @default true
 * @static
 */
Log.colorful = true;

/**
 * If true, logs will include the time mark.
 * @default true
 * @static
 */
Log.includeTime = true;

/**
 * Prefix included at the start of every log.
 * @default '[New Relic]'
 * @static
 */
Log.prefix = '[nrvideo]';

// PRIVATE MEMBERS

/**
 * Returns a console message
 *
 * @private
 * @param {array} msg Message array, error object or array of messages.
 * @param {Log.Level} [level=Log.Levels.NOTICE] Defines the level of the error sent.
 * Only errors with higher or equal level than Log.logLevel will be displayed.
 * @param {string} [color='darkgreen'] Color of the header
 * @see {@link Log.level}
 */
function _report(msg, level, color) {
  level = level || Log.Levels.NOTICE;
  color = color || 'darkcyan';

  var prefix = Log.prefix;
  if (Log.includeTime) prefix += _getCurrentTime() + ' ';
  prefix += _level2letter(level) + ':';

  // Show messages in actual console if level is enought
  if (Log.level <= level && level !== Log.Levels.SILENT) {
    if (!Log.colorful || typeof document !== 'undefined' && document.documentMode) {
      // document.documentMode exits only in IE
      _plainReport(msg, prefix);
    } else {
      // choose log method
      var logMethod;
      if (level === Log.Levels.ERROR && console.error) {
        logMethod = console.error;
      } else if (level === Log.Levels.WARNING && console.warn) {
        logMethod = console.warn;
      } else if (level === Log.Levels.DEBUG && console.debug) {
        logMethod = console.debug;
      } else {
        logMethod = console.log;
      }

      // print message
      prefix = '%c' + prefix;
      msg.splice(0, 0, prefix, 'color: ' + color);
      logMethod.apply(console, msg);
    }
  }
}

/**
 * Returns the current time in format hh:mm:ss.mmm (with trailing 0s)
 * @private
 * @return {string} Current time.
 */
function _getCurrentTime() {
  var d = new Date();
  var hh = ('0' + d.getDate()).slice(-2);
  var mm = ('0' + d.getMinutes()).slice(-2);
  var ss = ('0' + d.getSeconds()).slice(-2);
  var mmm = ('00' + d.getMilliseconds()).slice(-3);
  return '[' + hh + ':' + mm + ':' + ss + '.' + mmm + ']';
}

/**
 * Returns a console message without style
 *
 * @private
 * @param {(string|object|array)} msg Message string, object or array of messages.
 * @param {string} prefix Prefix of the message.
 */
function _plainReport(msg, prefix) {
  if (msg instanceof Array) {
    for (var m in msg) {
      _plainReport(msg[m], prefix);
    }
  } else {
    if (typeof msg === 'string') {
      console.log(prefix + ' ' + msg);
    } else {
      console.log(prefix + '↵');
      console.log(msg);
    }
  }
}

var _letters = {
  4: 'e', // Error
  3: 'w', // Warning
  2: 'n', // Notice
  1: 'd' // Debug


  /**
   * Transforms a level to a letter to identify every message.
   *
   * @private
   * @param {sLog.Level} level Level of the message
   */
};function _level2letter(level) {
  return _letters[level];
}

/**
 * This function is automatically executed at load.
 * Will search inside window.location.search for attribute 'nrvideo-debug=X'.
 * X can have one of these values, that will modify Log.Levels.
 * 5: SILENT,
 * 4: ERROR,
 * 3: WARNING,
 * 2: NOTICE,
 * 1: DEBUG,
 *
 * If nrvideo-colors=false is present, Log.colorful will be set to false.
 *
 * @private
 */
function _loadLevelFromUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    var m = /\?.*&*nrvideo-debug=(.+)/i.exec(window.location.search);
    if (m !== null) {
      if (m[1] === 'true') {
        Log.level = Log.Levels.ALL;
      } else {
        Log.level = m[1];
      }
    }

    var m2 = /\?.*&*nrvideo-colors=false/i.exec(window.location.search);
    if (m2 !== null) {
      Log.colorful = false;
    }
  }
}

// Execute load level
_loadLevelFromUrl();

exports.default = Log;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class calculates time lapses between two points on time.
 */
var Chrono = function () {
  /**
   * Constructor
   */
  function Chrono() {
    _classCallCheck(this, Chrono);

    this.reset();
  }

  /** Reset chrono values. */


  _createClass(Chrono, [{
    key: "reset",
    value: function reset() {
      /** Start time */
      this.startTime = 0;

      /** Stop time */
      this.stopTime = 0;

      /**
       * If you set an offset in a chrono, its value will be added getDeltaTime and stop.
       *
       * @example
       * let chrono = new Chrono()
       * chrono.offset = 500
       * chrono.start()
       * process.sleep(500)
       * chrono.stop() // Will return 1000
       *
       * @type {number}
       */
      this.offset = 0;
    }

    /**
     * Returns the time between start() and the last stop() in ms. Returns null if start wasn't
     * called.
     * @return {(number|null)} Time lapse in ms.
     */

  }, {
    key: "getDeltaTime",
    value: function getDeltaTime() {
      if (this.startTime) {
        return this.offset + (new Date().getTime() - this.startTime);
      } else {
        return null;
      }
    }

    /**
     * Starts the chrono.
     */

  }, {
    key: "start",
    value: function start() {
      this.startTime = new Date().getTime();
      this.stopTime = 0;
    }

    /**
     * Stops the timer and returns delta time.
     * @return {(number|null)} Returns the delta time
     */

  }, {
    key: "stop",
    value: function stop() {
      this.stopTime = new Date().getTime();
      return this.getDeltaTime();
    }

    /**
     * Creates a copy of the chrono.
     * @returns {Chrono} Cloned chrono
     */

  }, {
    key: "clone",
    value: function clone() {
      var chrono = new Chrono();
      chrono.startTime = this.startTime;
      chrono.stopTime = this.stopTime;
      chrono.offset = this.offset;
      return chrono;
    }
  }]);

  return Chrono;
}();

exports.default = Chrono;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.Core = exports.VideoTrackerState = exports.VideoTracker = exports.Tracker = exports.Emitter = exports.Log = exports.Chrono = exports.Constants = undefined;

var _core = __webpack_require__(8);

var _core2 = _interopRequireDefault(_core);

var _constants = __webpack_require__(9);

var _constants2 = _interopRequireDefault(_constants);

var _chrono = __webpack_require__(1);

var _chrono2 = _interopRequireDefault(_chrono);

var _log = __webpack_require__(0);

var _log2 = _interopRequireDefault(_log);

var _emitter = __webpack_require__(3);

var _emitter2 = _interopRequireDefault(_emitter);

var _tracker = __webpack_require__(4);

var _tracker2 = _interopRequireDefault(_tracker);

var _videotracker = __webpack_require__(10);

var _videotracker2 = _interopRequireDefault(_videotracker);

var _videotrackerstate = __webpack_require__(6);

var _videotrackerstate2 = _interopRequireDefault(_videotrackerstate);

var _package = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Constants = _constants2.default;
exports.Chrono = _chrono2.default;
exports.Log = _log2.default;
exports.Emitter = _emitter2.default;
exports.Tracker = _tracker2.default;
exports.VideoTracker = _videotracker2.default;
exports.VideoTrackerState = _videotrackerstate2.default;
exports.Core = _core2.default;
exports.version = _package.version;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This base class implements a basic behavior of listeners and events. Extend this object to have
 * this feature built-in inside your classes.
 *
 * @class Emitter
 */
var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: 'on',

    /**
     * Sets a listener to a given event. Use {@link emit} to trigger those events.
     * Pass '*' to listen ALL events.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event. Receives event and data.
     * @return this
     */
    value: function on(event, callback) {
      this._listeners = this._listeners || {};
      if (typeof callback === 'function') {
        this._listeners[event] = this._listeners[event] || [];
        this._listeners[event].push(callback);
        return this;
      }
    }

    /**
     * Removes given callback from the listeners of this object.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     * @return this
     */

  }, {
    key: 'off',
    value: function off(event, callback) {
      this._listeners = this._listeners || {};

      if (this._listeners[event]) {
        var index = this._listeners[event].indexOf(callback);
        if (index !== -1) {
          this._listeners[event].splice(index, 1);
        }
      }
      return this;
    }

    /**
     * Emits given event, triggering all the associated callbacks.
     *
     * @param {string} event Name of the event.
     * @param {object} [data] Custom data to be sent to the callbacks.
     * @return this
     */

  }, {
    key: 'emit',
    value: function emit(event, data) {
      var _this = this;

      this._listeners = this._listeners || {};
      data = data || {};

      if (Array.isArray(this._listeners[event])) {
        this._listeners[event].forEach(function (callback) {
          callback.call(_this, { type: event, data: data, target: _this });
        });
      }

      if (Array.isArray(this._listeners['*'])) {
        this._listeners['*'].forEach(function (callback) {
          callback.call(_this, { type: event, data: data, target: _this });
        });
      }

      return this;
    }
  }]);

  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _package = __webpack_require__(5);

var pkg = _interopRequireWildcard(_package);

var _emitter = __webpack_require__(3);

var _emitter2 = _interopRequireDefault(_emitter);

var _chrono = __webpack_require__(1);

var _chrono2 = _interopRequireDefault(_chrono);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Tracker class provides the basic logic to extend Newrelic's Browser Agent capabilities.
 * Trackers are designed to listen third party elements (like video tags, banners, etc.) and send
 * information over to Browser Agent. Extend this class to create your own tracker, override
 * registerListeners and unregisterListeners for full coverage!
 *
 * @example
 * Tracker instances should be added to Core library to start sending data:
 * nrvideo.Core.addTracker(new Tracker())
 *
 * @extends Emitter
 */
var Tracker = function (_Emitter) {
  _inherits(Tracker, _Emitter);

  /**
   * Constructor, receives options. You should call {@see registerListeners} after this.
   *
   * @param {Object} [options] Options for the tracker. See {@link setOptions}.
   */
  function Tracker(options) {
    _classCallCheck(this, Tracker);

    /**
     * If you add something to this custom dictionary it will be added to every action. If you set
     * any value, it will always override the values returned by the getters.
     *
     * @example
     * If you define tracker.customData.contentTitle = 'a' and tracker.getTitle() returns 'b'.
     * 'a' will prevail.
     */
    var _this = _possibleConstructorReturn(this, (Tracker.__proto__ || Object.getPrototypeOf(Tracker)).call(this));

    _this.customData = {};

    /**
     * Set time between hearbeats, in ms.
     */
    _this.heartbeat = null;

    /**
     * Another Tracker instance. Useful to relate ad Trackers to their parent content Trackers.
     * @type Tracker
     */
    _this.parentTracker = null;

    /**
     * Chrono that counts time since this class was instantiated.
     * @private
     */
    _this._trackerReadyChrono = new _chrono2.default();
    _this._trackerReadyChrono.start();

    options = options || {};
    _this.setOptions(options);
    return _this;
  }

  /**
   * Set options for the Tracker.
   *
   * @param {Object} [options] Options for the tracker.
   * @param {number} [options.heartbeat] Set time between heartbeats. See {@link heartbeat}.
   * @param {Object} [options.customData] Set custom data. See {@link customData}.
   * @param {Tracker} [options.parentTracker] Set parent tracker. See {@link parentTracker}.
   */


  _createClass(Tracker, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options) {
        if (options.parentTracker) this.parentTracker = options.parentTracker;
        if (options.customData) this.customData = options.customData;
        if (options.heartbeat) this.heartbeat = options.heartbeat;
      }
    }

    /**
     * Prepares tracker to dispose. Calls {@see unregisterListeners} and drops references.
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.unregisterListeners();
    }

    /**
     * Override this method to register listeners to third party elements.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.emit(Tracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'registerListeners',
    value: function registerListeners() {}

    /**
     * Override this method to unregister listeners to third party elements created with
     * {@see registerListeners}.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  unregisterListeners() {
     *    this.player.off('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.emit(Tracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {}

    /**
     * Returns heartbeat time interval. 30000 (30s) if not set. See {@link setOptions}.
     * @return {number} Heartbeat interval in ms.
     * @final
     */

  }, {
    key: 'getHeartbeat',
    value: function getHeartbeat() {
      if (this.heartbeat) {
        return this.heartbeat;
      } else if (this.parentTracker && this.parentTracker.heartbeat) {
        return this.parentTracker.heartbeat;
      } else {
        return 30000;
      }
    }

    /**
     * Starts heartbeating. Interval period set by options.heartbeat. Min 5000 ms.
     * This method is automaticaly called by the tracker once sendRequest is called.
     */

  }, {
    key: 'startHeartbeat',
    value: function startHeartbeat() {
      this._heartbeatInterval = setInterval(this.sendHeartbeat.bind(this), Math.max(this.getHeartbeat(), 5000));
    }

    /**
     * Stops heartbeating. This method is automaticaly called by the tracker.
     */

  }, {
    key: 'stopHeartbeat',
    value: function stopHeartbeat() {
      if (this._heartbeatInterval) {
        clearInterval(this._heartbeatInterval);
      }
    }

    /**
     * Heartbeating allows you to call this function each X milliseconds, defined by
     * {@link getHeartbeat}. This is useful to send regular events to track changes.
     *
     * By default it will send {@link Tracker.Events.HEARTBEAT}.
     * To start heartbeating use {@link startHeartbeat} and to stop them use {@link stopHeartbeat}.
     *
     * @example
     * Override this method to define your own Heartbeat reporting.
     *
     * class TrackerChild extends Tracker {
     *  sendHeartbeat (att) {
     *    this.send('MY_HEARBEAT_EVENT')
     *  }
     * }
     *
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendHeartbeat',
    value: function sendHeartbeat(att) {
      this.send(Tracker.Events.HEARTBEAT, att);
    }

    /**
     * Override this method to return attributes for actions.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  getAttributes(att) {
     *    att = att || {}
     *    att.information = 'something'
     *    return att
     *  }
     * }
     *
     * @param {object} [att] Collection of key value attributes
     * @return {object} Filled attributes
     * @final
     */

  }, {
    key: 'getAttributes',
    value: function getAttributes(att) {
      att = att || {};
      att.trackerName = this.getTrackerName();
      att.trackerVersion = this.getTrackerVersion();
      att.coreVersion = pkg.version;
      att.timeSinceTrackerReady = this._trackerReadyChrono.getDeltaTime();

      for (var key in this.customData) {
        att[key] = this.customData[key];
      }

      return att;
    }

    /** Override to change of the Version of tracker. ie: '1.0.1' */

  }, {
    key: 'getTrackerVersion',
    value: function getTrackerVersion() {
      return pkg.version;
    }

    /** Override to change of the Name of the tracker. ie: 'custom-html5' */

  }, {
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'base-tracker';
    }

    /**
     * Send given event. Will automatically call {@see getAttributes} to fill information.
     * Internally, this will call {@see Emitter#emit}, so you could listen any event fired.
     *
     * @example
     * tracker.send('BANNER_CLICK', { url: 'http....' })
     *
     * @param {string} event Event name
     * @param {object} [att] Key:value dictionary filled with attributes.
     */

  }, {
    key: 'send',
    value: function send(event, att) {
      this.emit(event, this.getAttributes(att));
    }
  }]);

  return Tracker;
}(_emitter2.default);

/**
 * Enumeration of events fired by this class.
 *
 * @static
 * @memberof Tracker
 * @enum
 */


Tracker.Events = {
  HEARTBEAT: 'HEARTBEAT'
};

exports.default = Tracker;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = {"_from":"github:newrelic/video-core-js#v0.10.0","_id":"newrelic-video-core@0.10.0","_inBundle":false,"_location":"/newrelic-video-core","_phantomChildren":{},"_requested":{"type":"git","raw":"newrelic-video-core@github:newrelic/video-core-js#v0.10.0","name":"newrelic-video-core","escapedName":"newrelic-video-core","rawSpec":"github:newrelic/video-core-js#v0.10.0","saveSpec":"github:newrelic/video-core-js#v0.10.0","fetchSpec":null,"gitCommittish":"v0.10.0"},"_requiredBy":["/"],"_resolved":"github:newrelic/video-core-js#5c39206664b1fa0a5647a2a9e9c5a9c326cca41c","_spec":"newrelic-video-core@github:newrelic/video-core-js#v0.10.0","_where":"G:\\workspace\\newrelic\\nrvideo\\gpt","author":{"name":"Jordi Aguilar"},"bugs":{"url":"https://github.com/newrelic/video-core-js/issues"},"bundleDependencies":false,"dependencies":{},"deprecated":false,"description":"New Relic video tracking core library","devDependencies":{"aws-sdk":"^2.150.0","babel-core":"^6.25.0","babel-loader":"^7.1.1","babel-preset-env":"^1.6.0","chai":"^4.1.0","ink-docstrap":"^1.3.0","jsdoc":"^3.5.4","jsdoc-babel":"^0.3.0","mocha":"^3.5.0","nyc":"^11.1.0","sinon":"^2.4.1","webpack":"^3.4.1"},"homepage":"https://github.com/newrelic/video-core-js#readme","license":"MIT","main":"src/index.js","name":"newrelic-video-core","repository":{"type":"git","url":"git+https://github.com/newrelic/video-core-js.git"},"scripts":{"build":"webpack -p","build:dev":"webpack","clean":"rm -rf dist coverage doc","deploy":"node scripts/deploy.js","doc":"jsdoc -c jsdoc.json -d doc","test":"nyc --reporter=html --reporter=text mocha --compilers js:babel-core/register","watch":"webpack -p --progress --color --watch","watch:dev":"webpack --progress --color --watch"},"version":"0.10.0"}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chrono = __webpack_require__(1);

var _chrono2 = _interopRequireDefault(_chrono);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * State machine for a VideoTracker and its monitored video.
 */
var VideoTrackerState = function () {
  /** Constructor */
  function VideoTrackerState() {
    _classCallCheck(this, VideoTrackerState);

    this.reset();

    /**
     * Time when the VideoTrackerState was initializated.
     * @private
     */
    this._createdAt = Date.now();
  }

  /** Resets all flags and chronos. */


  _createClass(VideoTrackerState, [{
    key: 'reset',
    value: function reset() {
      /**
       * Unique identifier of the view.
       * @private
       */
      this._viewSession = null;

      /**
       * Number of views seen.
       * @private
       */
      this._viewCount = 0;

      /**
       * True if it is tracking ads.
       * @private
       */
      this._isAd = false;

      /**
       * Number of errors fired. 'End' resets it.
       */
      this.numberOfErrors = 0;

      /**
       * Number of ads shown.
       */
      this.numberOfAds = 0;

      /**
       * Number of videos played.
       */
      this.numberOfVideos = 0;

      /**
       * The amount of ms the user has been watching content (not paused, not buffering, not ads...)
       */
      this.totalPlaytime = 0;

      this.resetFlags();
      this.resetChronos();
    }

    /** Resets flags. */

  }, {
    key: 'resetFlags',
    value: function resetFlags() {
      /** True once the player has finished loading. */
      this.isPlayerReady = false;

      /** True if the video has been user-requested to play. ie: user cicks play. */
      this.isRequested = false;

      /** True if the video has starting playing. ie: actual images/audio showing in screen. */
      this.isStarted = false;

      /** True if the video is paused. */
      this.isPaused = false;

      /** True if the video is performing a seek action. */
      this.isSeeking = false;

      /** True if the video is currently buffering. */
      this.isBuffering = false;

      /** True if you are in the middle of an ad break. */
      this.isAdBreak = false;

      /** True if the video is currently playing (not buffering, not paused...) */
      this.isPlaying = false;
    }

    /** Resets chronos. */

  }, {
    key: 'resetChronos',
    value: function resetChronos() {
      /** Chrono that counts time since last requested event. */
      this.timeSinceRequested = new _chrono2.default();

      /** Chrono that counts time since last start event. */
      this.timeSinceStarted = new _chrono2.default();

      /** Chrono that counts time since last pause event. */
      this.timeSincePaused = new _chrono2.default();

      /** Chrono that counts time since last seeking start event. */
      this.timeSinceSeekBegin = new _chrono2.default();

      /** Chrono that counts time since last buffering start event. */
      this.timeSinceBufferBegin = new _chrono2.default();

      /** Chrono that counts time since last ad break start event. */
      this.timeSinceAdBreakStart = new _chrono2.default();

      /** Chrono that counts time since last download event. */
      this.timeSinceLastDownload = new _chrono2.default();

      /** Chrono that counts time since last heartbeat. */
      this.timeSinceLastHeartbeat = new _chrono2.default();

      /** Chrono that counts time since last rendition change. */
      this.timeSinceLastRenditionChange = new _chrono2.default();

      /** Ads only. Chrono that counts time since last ad quartile. */
      this.timeSinceLastAdQuartile = new _chrono2.default();

      /** Content only. Chrono that counts time since last AD_END. */
      this.timeSinceLastAd = new _chrono2.default();

      /** Chrono that counts the ammount of time the video have been playing since the last event. */
      this.playtimeSinceLastEvent = new _chrono2.default();
    }

    /** Returns true if the tracker is currently on ads. */

  }, {
    key: 'isAd',
    value: function isAd() {
      return this._isAd;
    }

    /** Sets if the tracker is currenlty tracking ads */

  }, {
    key: 'setIsAd',
    value: function setIsAd(isAd) {
      this._isAd = isAd;
    }

    /**
     * Returns a random-generated view Session ID, useful to sort by views.
     */

  }, {
    key: 'getViewSession',
    value: function getViewSession() {
      if (!this._viewSession) {
        var time = new Date().getTime();
        var random = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);

        this._viewSession = time + '-' + random;
      }

      return this._viewSession;
    }

    /**
     * Returns a random-generated view Session ID, plus a view count, allowing you to distinguish
     * between two videos played in the same session.
     */

  }, {
    key: 'getViewId',
    value: function getViewId() {
      return this.getViewSession() + '-' + this._viewCount;
    }

    /**
     * Fills given object with state-based attributes.
     *
     * @param {object} att Collection fo key value attributes
     * @return {object} Filled attributes
     */

  }, {
    key: 'getStateAttributes',
    value: function getStateAttributes(att) {
      att = att || {};

      if (this.isAd()) {
        // Ads only
        if (this.isRequested) {
          att.timeSinceAdRequested = this.timeSinceRequested.getDeltaTime();
          att.timeSinceLastAdHeartbeat = this.timeSinceLastHeartbeat.getDeltaTime();
        }
        if (this.isStarted) att.timeSinceAdStarted = this.timeSinceStarted.getDeltaTime();
        if (this.isPaused) att.timeSinceAdPaused = this.timeSincePaused.getDeltaTime();
        if (this.isBuffering) att.timeSinceAdBufferBegin = this.timeSinceBufferBegin.getDeltaTime();
        if (this.isSeeking) att.timeSinceAdSeekBegin = this.timeSinceSeekBegin.getDeltaTime();
        if (this.isAdBreak) att.timeSinceAdBreakBegin = this.timeSinceAdBreakStart.getDeltaTime();
        att.numberOfAds = this.numberOfAds;
      } else {
        // Content only
        if (this.isRequested) {
          att.timeSinceRequested = this.timeSinceRequested.getDeltaTime();
          att.timeSinceLastHeartbeat = this.timeSinceLastHeartbeat.getDeltaTime();
        }
        if (this.isStarted) att.timeSinceStarted = this.timeSinceStarted.getDeltaTime();
        if (this.isPaused) att.timeSincePaused = this.timeSincePaused.getDeltaTime();
        if (this.isBuffering) att.timeSinceBufferBegin = this.timeSinceBufferBegin.getDeltaTime();
        if (this.isSeeking) att.timeSinceSeekBegin = this.timeSinceSeekBegin.getDeltaTime();
        att.timeSinceLastAd = this.timeSinceLastAd.getDeltaTime();
        att.numberOfVideos = this.numberOfVideos;
      }
      att.numberOfErrors = this.numberOfErrors;

      // Playtime
      if (!this.isAd()) {
        // Content only
        if (this.playtimeSinceLastEvent.startTime > 0) {
          att.playtimeSinceLastEvent = this.playtimeSinceLastEvent.getDeltaTime();
        } else {
          att.playtimeSinceLastEvent = 0;
        }
        if (this.isPlaying) {
          this.playtimeSinceLastEvent.start();
        } else {
          this.playtimeSinceLastEvent.reset();
        }
        this.totalPlaytime += att.playtimeSinceLastEvent;
        att.totalPlaytime = this.totalPlaytime;
      }

      return att;
    }

    /**
     * Augments view count. This will be called with each *_START and *_END.
     */

  }, {
    key: 'goViewCountUp',
    value: function goViewCountUp() {
      this._viewCount++;
    }

    /**
     * Checks flags and changes state.
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goPlayerReady',
    value: function goPlayerReady() {
      if (!this.isPlayerReady) {
        this.isPlayerReady = true;
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goRequest',
    value: function goRequest() {
      if (!this.isRequested) {
        this.isRequested = true;
        this.timeSinceLastAd.reset();
        this.timeSinceRequested.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goStart',
    value: function goStart() {
      if (this.isRequested && !this.isStarted) {
        if (this.isAd()) {
          this.numberOfAds++;
        } else {
          this.numberOfVideos++;
        }
        this.isStarted = true;
        this.isPlaying = true;
        this.timeSinceStarted.start();
        this.playtimeSinceLastEvent.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goEnd',
    value: function goEnd() {
      if (this.isRequested) {
        this.numberOfErrors = 0;
        this.isPlaying = false;
        this.resetFlags();
        this.timeSinceRequested.stop();
        this.timeSinceStarted.stop();
        this.playtimeSinceLastEvent.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goPause',
    value: function goPause() {
      if (this.isStarted && !this.isPaused) {
        this.isPaused = true;
        this.isPlaying = false;
        this.timeSincePaused.start();
        this.playtimeSinceLastEvent.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goResume',
    value: function goResume() {
      if (this.isStarted && this.isPaused) {
        this.isPaused = false;
        this.isPlaying = true;
        this.timeSincePaused.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goBufferStart',
    value: function goBufferStart() {
      if (this.isStarted && !this.isBuffering) {
        this.isBuffering = true;
        this.isPlaying = false;
        this.timeSinceBufferBegin.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goBufferEnd',
    value: function goBufferEnd() {
      if (this.isStarted && this.isBuffering) {
        this.isBuffering = false;
        this.isPlaying = true;
        this.timeSinceBufferBegin.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goSeekStart',
    value: function goSeekStart() {
      if (this.isStarted && !this.isSeeking) {
        this.isSeeking = true;
        this.isPlaying = false;
        this.timeSinceSeekBegin.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goSeekEnd',
    value: function goSeekEnd() {
      if (this.isStarted && this.isSeeking) {
        this.isSeeking = false;
        this.isPlaying = true;
        this.timeSinceSeekBegin.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goAdBreakStart',
    value: function goAdBreakStart() {
      if (!this.isAdBreak) {
        this.isAdBreak = true;
        this.timeSinceAdBreakStart.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goAdBreakEnd',
    value: function goAdBreakEnd() {
      if (this.isAdBreak) {
        this.isAdBreak = false;
        this.timeSinceAdBreakStart.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Restarts download chrono.
     */

  }, {
    key: 'goDownload',
    value: function goDownload() {
      this.timeSinceLastDownload.start();
    }

    /**
     * Restarts heartbeat chrono.
     */

  }, {
    key: 'goHeartbeat',
    value: function goHeartbeat() {
      this.timeSinceLastHeartbeat.start();
    }

    /**
     * Restarts rendition change chrono.
     */

  }, {
    key: 'goRenditionChange',
    value: function goRenditionChange() {
      this.timeSinceLastRenditionChange.start();
    }

    /**
     * Restarts ad quartile chrono.
     */

  }, {
    key: 'goAdQuartile',
    value: function goAdQuartile() {
      this.timeSinceLastAdQuartile.start();
    }

    /**
     * Increments error counter.
     */

  }, {
    key: 'goError',
    value: function goError() {
      this.numberOfErrors++;
    }

    /**
     * Restarts last ad chrono.
     */

  }, {
    key: 'goLastAd',
    value: function goLastAd() {
      this.timeSinceLastAd.start();
    }
  }]);

  return VideoTrackerState;
}();

exports.default = VideoTrackerState;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _newrelicVideoCore = __webpack_require__(2);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _tracker = __webpack_require__(11);

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

nrvideo.GooglePublisherTagTracker = _tracker2.default;

if (window.addEventListener) {
  window.addEventListener('load', _tracker2.default.init, false);
} else if (window.attachEvent) {
  window.attachEvent('onload', _tracker2.default.init);
}

module.exports = nrvideo;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _log = __webpack_require__(0);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Static class that sums up core functionalities of the library.
 * @static
 */
var Core = function () {
  function Core() {
    _classCallCheck(this, Core);
  }

  _createClass(Core, null, [{
    key: 'addTracker',

    /**
     * Add a tracker to the system. Trackers added will start reporting its events to NR's backend.
     *
     * @param {(Emitter|Tracker)} tracker
     */
    value: function addTracker(tracker) {
      if (tracker.on && tracker.emit) {
        trackers.push(tracker);
        tracker.on('*', eventHandler);
      } else {
        _log2.default.error('Tried to load a non-tracker.', tracker);
      }
    }

    /**
     * Disposes and remove given tracker. Removes its listeners.
     *
     * @param {Tracker} tracker Tracker to remove.
     */

  }, {
    key: 'removeTracker',
    value: function removeTracker(tracker) {
      tracker.off('*', eventHandler);
      tracker.dispose();
      var index = trackers.indexOf(tracker);
      if (index !== -1) trackers.splice(index, 1);
    }

    /**
     * Returns the array of trackers.
     *
     * @returns {Tracker[]} Array of trackers.
     */

  }, {
    key: 'getTrackers',
    value: function getTrackers() {
      return trackers;
    }

    /**
     * Sends given event. Uses newrelic Browser Agent.
     * @param {String} event Event to send.
     * @param {Object} data Data associated to the event.
     */

  }, {
    key: 'send',
    value: function send(event, data) {
      if (typeof newrelic !== 'undefined' && newrelic.addPageAction) {
        newrelic.addPageAction(event, data);
      } else {
        if (!isErrorShown) {
          _log2.default.error('newrelic.addPageAction() is not available.', 'In order to use NewRelic Video you will need New Relic Browser Agent.');
          isErrorShown = true;
        }
      }
    }

    /**
     * Sends an error event. This may be used for external errors launched by the app, the network or
     * any external factor. Note that errors within the player are normally reported with
     * tracker.sendError, so this method should not be used to report those.
     *
     * @param {object} att attributes to be sent along the error.
     */

  }, {
    key: 'sendError',
    value: function sendError(att) {
      Core.send('ERROR', att);
    }
  }]);

  return Core;
}();

var trackers = [];
var isErrorShown = false;

/**
 * Logs and sends given event.
 *
 * @private
 * @param {Event} e Event
 */
function eventHandler(e) {
  var data = cleanData(e.data);
  if (_log2.default.level <= _log2.default.Levels.DEBUG) {
    _log2.default.notice('Sent', e.type, data);
  } else {
    _log2.default.notice('Sent', e.type);
  }
  Core.send(e.type, data);
}

/**
 * Cleans given object, removing all items with value === null.
 * @private
 * @param {Object} data Data to clean
 * @returns {Object} Cleaned object
 */
function cleanData(data) {
  var ret = {};
  for (var i in data) {
    if (data[i] !== null && typeof data[i] !== 'undefined') ret[i] = data[i];
  }
  return ret;
}

exports.default = Core;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Constants for the library.
 * @class Constants
 * @static
 */
var Constants = function Constants() {
  _classCallCheck(this, Constants);
};

/**
 * Enum for types/positions of ads.
 * @example var type = Constants.AdPositions.PRE
 * @enum {String}
 */


Constants.AdPositions = {
  /** For ads shown before the content. */
  PRE: 'pre',
  /** For ads shown during the content. */
  MID: 'mid',
  /** For ads shown after the content. */
  POST: 'post'
};

exports.default = Constants;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _log = __webpack_require__(0);

var _log2 = _interopRequireDefault(_log);

var _tracker = __webpack_require__(4);

var _tracker2 = _interopRequireDefault(_tracker);

var _videotrackerstate = __webpack_require__(6);

var _videotrackerstate2 = _interopRequireDefault(_videotrackerstate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base video tracker class provides extensible tracking over video elements. See {@link Tracker}.
 * Extend this class to create your own video tracker class. Override getter methods and
 * registerListeners/unregisterListeners to provide full integration with your video experience.
 *
 * @example
 * Tracker instances should be added to Core library to start sending data:
 * nrvideo.Core.addTracker(new Tracker())
 *
 * @extends Tracker
 */
var VideoTracker = function (_Tracker) {
  _inherits(VideoTracker, _Tracker);

  /**
   * Constructor, receives player and options.
   * Lifecycle: constructor > {@link setOptions} > {@link setPlayer} > {@link registerListeners}.
   *
   * @param {Object} [player] Player to track. See {@link setPlayer}.
   * @param {Object} [options] Options for the tracker. See {@link setOptions}.
   */
  function VideoTracker(player, options) {
    _classCallCheck(this, VideoTracker);

    /**
     * TrackerState instance. Stores the state of the view. Tracker will automatically update the
     * state of its instance, so there's no need to modify/interact with it manually.
     * @type TrackerState
     */
    var _this = _possibleConstructorReturn(this, (VideoTracker.__proto__ || Object.getPrototypeOf(VideoTracker)).call(this));

    _this.state = new _videotrackerstate2.default();

    /**
     * Another Tracker instance to track ads.
     * @type Tracker
     */
    _this.adsTracker = null;

    options = options || {};
    _this.setOptions(options);
    if (player) _this.setPlayer(player, options.tag);

    _log2.default.notice('Tracker ' + _this.getTrackerName() + ' v' + _this.getTrackerVersion() + ' is ready.');
    return _this;
  }

  /**
   * Set options for the Tracker.
   *
   * @param {Object} [options] Options for the tracker.
   * @param {Boolean} [options.isAd] True if the tracker is tracking ads. See {@link setIsAd}.
   * @param {number} [options.heartbeat] Set time between heartbeats. See {@link heartbeat}.
   * @param {Object} [options.customData] Set custom data. See {@link customData}.
   * @param {Tracker} [options.parentTracker] Set parent tracker. See {@link parentTracker}.
   * @param {Tracker} [options.adsTracker] Set ads tracker. See {@link adsTracker}.
   * @param {Object} [options.tag] DOM element to track. See {@link setPlayer}.
   */


  _createClass(VideoTracker, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options) {
        if (options.adsTracker) this.setAdsTracker(options.adsTracker);
        if (typeof options.isAd === 'boolean') this.setIsAd(options.isAd);
        _tracker2.default.prototype.setOptions.apply(this, arguments);
      }
    }

    /**
     * Set a player and/or a tag. If there was one already defined, it will call dispose() first.
     * Will call this.registerListeners() afterwards.
     *
     * @param {Object|string} player New player to save as this.player. If a string is passed,
     * document.getElementById will be called.
     * @param {DOMObject|string} [tag] Optional DOMElement to save as this.tag. If a string is passed,
     * document.getElementById will be called.
     */

  }, {
    key: 'setPlayer',
    value: function setPlayer(player, tag) {
      if (this.player || this.tag) this.dispose();

      if (typeof document !== 'undefined' && document.getElementById) {
        if (typeof player === 'string') player = document.getElementById(player);
        if (typeof tag === 'string') tag = document.getElementById(tag);
      }

      tag = tag || player; // if no tag is passed, use player as both.

      this.player = player;
      this.tag = tag;
      this.registerListeners();
    }

    /** Returns true if the tracker is currently on ads. */

  }, {
    key: 'isAd',
    value: function isAd() {
      return this.state.isAd();
    }

    /** Sets if the tracker is currenlty tracking ads */

  }, {
    key: 'setIsAd',
    value: function setIsAd(isAd) {
      this.state.setIsAd(isAd);
    }

    /**
     * Use this function to set up a child ad tracker. You will be able to access it using
     * this.adsTracker.
     *
     * @param {Tracker} tracker Ad tracker to add
     */

  }, {
    key: 'setAdsTracker',
    value: function setAdsTracker(tracker) {
      this.disposeAdsTracker(); // dispose current one
      if (tracker) {
        this.adsTracker = tracker;
        this.adsTracker.setIsAd(true);
        this.adsTracker.parentTracker = this;
        this.adsTracker.on('*', funnelAdEvents.bind(this));
      }
    }

    /**
     * Dispose current adsTracker.
     */

  }, {
    key: 'disposeAdsTracker',
    value: function disposeAdsTracker() {
      if (this.adsTracker) {
        this.adsTracker.off('*', funnelAdEvents);
        this.adsTracker.dispose();
      }
    }

    /**
     * Prepares tracker to dispose. Calls unregisterListener and drops references to player and tag.
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.stopHeartbeat();
      this.disposeAdsTracker();
      this.unregisterListeners();
      this.player = null;
      this.tag = null;
    }

    /**
     * Override this method to register listeners to player/tag.
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.send(VideoTracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'registerListeners',
    value: function registerListeners() {}

    /**
     * Override this method to unregister listeners to player/tag created in registerListeners
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  unregisterListeners() {
     *    this.player.off('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.send(VideoTracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {}

    /**
     * Trackers will generate unique id's for every new video iteration. If you have your own unique
     * view value, you can override this method to return it.
     * If the tracker has a parentTracker defined, parent viewId will be used.
     */

  }, {
    key: 'getViewId',
    value: function getViewId() {
      if (this.parentTracker) {
        return this.parentTracker.getViewId();
      } else {
        return this.state.getViewId();
      }
    }

    /**
     * Trackers will generate unique id's for every new video session. If you have your own unique
     * view value, you can override this method to return it.
     * If the tracker has a parentTracker defined, parent viewId will be used.
     */

  }, {
    key: 'getViewSession',
    value: function getViewSession() {
      if (this.parentTracker) {
        return this.parentTracker.getViewSession();
      } else {
        return this.state.getViewSession();
      }
    }

    /** Override to return the Id of the video. */

  }, {
    key: 'getVideoId',
    value: function getVideoId() {
      return null;
    }

    /** Override to return Title of the video. */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      return null;
    }

    /** Override to return True if the video is live. */

  }, {
    key: 'isLive',
    value: function isLive() {
      return null;
    }

    /** Override to return Bitrate (in bits) of the video. */

  }, {
    key: 'getBitrate',
    value: function getBitrate() {
      return null;
    }

    /** Calculates consumed bitrate using webkitVideoDecodedByteCount. */

  }, {
    key: 'getWebkitBitrate',
    value: function getWebkitBitrate() {
      if (this.tag && this.tag.webkitVideoDecodedByteCount) {
        var bitrate = void 0;
        if (this._lastWebkitBitrate) {
          bitrate = this.tag.webkitVideoDecodedByteCount;
          var delta = bitrate - this._lastWebkitBitrate;
          var seconds = this.getHeartbeat() / 1000;
          bitrate = Math.round(delta / seconds * 8);
        }
        this._lastWebkitBitrate = this.tag.webkitVideoDecodedByteCount;
        return bitrate || null;
      }
    }

    /** Override to return Name of the rendition (ie: 1080p). */

  }, {
    key: 'getRenditionName',
    value: function getRenditionName() {
      return null;
    }

    /** Override to return Target Bitrate of the rendition. */

  }, {
    key: 'getRenditionBitrate',
    value: function getRenditionBitrate() {
      return null;
    }

    /**
     * This method will return 'up', 'down' or null depending on if the bitrate of the rendition
     * have changed from the last time it was called.
     *
     * @param {boolean} [saveNewRendition=false] If true, current rendition will be stored to be used
     * the next time this method is called. This allows you to call this.getRenditionShift() without
     * saving the current rendition and thus preventing interferences with RENDITION_CHANGE events.
     */

  }, {
    key: 'getRenditionShift',
    value: function getRenditionShift(saveNewRendition) {
      var current = this.getRenditionBitrate();
      var last = void 0;
      if (this.isAd()) {
        last = this._lastAdRendition;
        if (saveNewRendition) this._lastAdRendition = current;
      } else {
        last = this._lastRendition;
        if (saveNewRendition) this._lastRendition = current;
      }

      if (!current || !last) {
        return null;
      } else {
        if (current > last) {
          return 'up';
        } else if (current < last) {
          return 'down';
        } else {
          return null;
        }
      }
    }

    /** Override to return renidtion actual Height (before re-scaling). */

  }, {
    key: 'getRenditionHeight',
    value: function getRenditionHeight() {
      return this.tag ? this.tag.videoHeight : null;
    }

    /** Override to return rendition actual Width (before re-scaling). */

  }, {
    key: 'getRenditionWidth',
    value: function getRenditionWidth() {
      return this.tag ? this.tag.videoWidth : null;
    }

    /** Override to return Duration of the video, in ms. */

  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.tag ? this.tag.duration : null;
    }

    /** Override to return Playhead (currentTime) of the video, in ms. */

  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      return this.tag ? this.tag.currentTime : null;
    }

    /**
     * Override to return Language of the video. We recommend using locale notation, ie: en_US.
     * {@see https://gist.github.com/jacobbubu/1836273}
     */

  }, {
    key: 'getLanguage',
    value: function getLanguage() {
      return null;
    }

    /** Override to return URL of the resource being played. */

  }, {
    key: 'getSrc',
    value: function getSrc() {
      return this.tag ? this.tag.currentSrc : null;
    }

    /** Override to return Playrate (speed) of the video. ie: 1.0, 0.5, 1.25... */

  }, {
    key: 'getPlayrate',
    value: function getPlayrate() {
      return this.tag ? this.tag.playbackRate : null;
    }

    /** Override to return True if the video is currently muted. */

  }, {
    key: 'isMuted',
    value: function isMuted() {
      return this.tag ? this.tag.muted : null;
    }

    /** Override to return True if the video is currently fullscreen. */

  }, {
    key: 'isFullscreen',
    value: function isFullscreen() {
      return null;
    }

    /** Override to return the CDN serving the content. */

  }, {
    key: 'getCdn',
    value: function getCdn() {
      return null;
    }

    /** Override to return the Name of the player. */

  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return this.getTrackerName();
    }

    /** Override to return the Version of the player. */

  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return null;
    }

    /** Override to return current FPS (Frames per second). */

  }, {
    key: 'getFps',
    value: function getFps() {
      return null;
    }

    /**
     * Override to return if the player was autoplayed. By default: this.tag.autoplay
     */

  }, {
    key: 'isAutoplayed',
    value: function isAutoplayed() {
      return this.tag ? this.tag.autoplay : null;
    }

    /**
     * Override to return the player preload attribute. By default: this.tag.preload
     */

  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this.tag ? this.tag.preload : null;
    }

    // Only for ads
    /**
     * Override to return Quartile of the ad. 0 before first, 1 after first quartile, 2 after
     * midpoint, 3 after third quartile, 4 when completed.
     */

  }, {
    key: 'getAdQuartile',
    value: function getAdQuartile() {
      return null;
    }

    /**
     * Override to return the position of the ad. Use {@link Constants.AdPositions} enum
     * to fill this data.
     */

  }, {
    key: 'getAdPosition',
    value: function getAdPosition() {
      return this.state.isStarted ? 'pre' : 'mid';
    }

    /**
     * Override to return the ad partner. ie: ima, freewheel...
     */

  }, {
    key: 'getAdPartner',
    value: function getAdPartner() {
      return null;
    }

    /**
     * Override to return the creative id of the ad.
     */

  }, {
    key: 'getAdCreativeId',
    value: function getAdCreativeId() {
      return null;
    }

    /**
     * Do NOT override. This method fills all the appropiate attributes for tracked video.
     *
     * @param {object} [att] Collection of key value attributes
     * @return {object} Filled attributes
     * @final
     */

  }, {
    key: 'getAttributes',
    value: function getAttributes(att) {
      att = _tracker2.default.prototype.getAttributes.apply(this, arguments);

      if (typeof att.isAd === 'undefined') att.isAd = this.isAd();
      att.viewSession = this.getViewSession();
      att.viewId = this.getViewId();
      att.playerName = this.getPlayerName();
      att.playerVersion = this.getPlayerVersion();

      try {
        att.pageUrl = window.location.href;
      } catch (err) {/* skip */}

      if (this.isAd()) {
        // Ads
        att.adId = this.getVideoId();
        att.adTitle = this.getTitle();
        att.adBitrate = this.getBitrate() || this.getWebkitBitrate();
        att.adRenditionName = this.getRenditionName();
        att.adRenditionBitrate = this.getRenditionBitrate();
        att.adRenditionHeight = this.getRenditionHeight();
        att.adRenditionWidth = this.getRenditionWidth();
        att.adDuration = this.getDuration();
        att.adPlayhead = this.getPlayhead();
        att.adLanguage = this.getLanguage();
        att.adSrc = this.getSrc();
        att.adCdn = this.getCdn();
        att.adIsMuted = this.isMuted();
        att.adFps = this.getFps();
        // ad exclusives
        att.adQuartile = this.getAdQuartile();
        att.adPosition = this.getAdPosition();
        att.adCreativeId = this.getAdCreativeId();
        att.adPartner = this.getAdPartner();
      } else {
        // no ads
        att.contentId = this.getVideoId();
        att.contentTitle = this.getTitle();
        att.contentIsLive = this.isLive();
        att.contentBitrate = this.getBitrate() || this.getWebkitBitrate();
        att.contentRenditionName = this.getRenditionName();
        att.contentRenditionBitrate = this.getRenditionBitrate();
        att.contentRenditionHeight = this.getRenditionHeight();
        att.contentRenditionWidth = this.getRenditionWidth();
        att.contentDuration = this.getDuration();
        att.contentPlayhead = this.getPlayhead();
        att.contentLanguage = this.getLanguage();
        att.contentSrc = this.getSrc();
        att.contentPlayrate = this.getPlayrate();
        att.contentIsFullscreen = this.isFullscreen();
        att.contentIsMuted = this.isMuted();
        att.contentCdn = this.getCdn();
        att.contentIsAutoplayed = this.isAutoplayed();
        att.contentPreload = this.getPreload();
        att.contentFps = this.getFps();
      }

      this.state.getStateAttributes(att);

      for (var key in this.customData) {
        att[key] = this.customData[key];
      }

      return att;
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendPlayerReady',
    value: function sendPlayerReady(att) {
      if (this.state.goPlayerReady()) {
        att = att || {};
        this.send(VideoTracker.Events.PLAYER_READY, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners. Calls
     * {@link startHeartbeat}.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendRequest',
    value: function sendRequest(att) {
      if (this.state.goRequest()) {
        this.state.goViewCountUp();
        var ev = this.isAd() ? VideoTracker.Events.AD_REQUEST : VideoTracker.Events.CONTENT_REQUEST;
        this.send(ev, att);
        this.startHeartbeat();
        this.state.goHeartbeat();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendStart',
    value: function sendStart(att) {
      if (this.state.goStart()) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_START;
          if (this.parentTracker) this.parentTracker.state.isPlaying = false;
        } else {
          ev = VideoTracker.Events.CONTENT_START;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners. Calls
     * {@link stopHeartbeat}.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendEnd',
    value: function sendEnd(att) {
      if (this.state.goEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_END;
          att.timeSinceAdRequested = this.state.timeSinceRequested.getDeltaTime();
          att.timeSinceAdStarted = this.state.timeSinceStarted.getDeltaTime();
          if (this.parentTracker) this.parentTracker.state.isPlaying = true;
        } else {
          ev = VideoTracker.Events.CONTENT_END;
          att.timeSinceRequested = this.state.timeSinceRequested.getDeltaTime();
          att.timeSinceStarted = this.state.timeSinceStarted.getDeltaTime();
        }
        this.stopHeartbeat();
        this.send(ev, att);
        if (this.parentTracker && this.isAd()) this.parentTracker.state.goLastAd();

        this.state.goViewCountUp();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendPause',
    value: function sendPause(att) {
      if (this.state.goPause()) {
        var ev = this.isAd() ? VideoTracker.Events.AD_PAUSE : VideoTracker.Events.CONTENT_PAUSE;
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendResume',
    value: function sendResume(att) {
      if (this.state.goResume()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_RESUME;
          att.timeSinceAdPaused = this.state.timeSincePaused.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_RESUME;
          att.timeSincePaused = this.state.timeSincePaused.getDeltaTime();
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendBufferStart',
    value: function sendBufferStart(att) {
      if (this.state.goBufferStart()) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_BUFFER_START;
        } else {
          ev = VideoTracker.Events.CONTENT_BUFFER_START;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendBufferEnd',
    value: function sendBufferEnd(att) {
      if (this.state.goBufferEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_BUFFER_END;
          att.timeSinceAdBufferBegin = this.state.timeSinceBufferBegin.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_BUFFER_END;
          att.timeSinceBufferBegin = this.state.timeSinceBufferBegin.getDeltaTime();
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendSeekStart',
    value: function sendSeekStart(att) {
      if (this.state.goSeekStart()) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_SEEK_START;
        } else {
          ev = VideoTracker.Events.CONTENT_SEEK_START;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendSeekEnd',
    value: function sendSeekEnd(att) {
      if (this.state.goSeekEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_SEEK_END;
          att.timeSinceAdSeekBegin = this.state.timeSinceSeekBegin.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_SEEK_END;
          att.timeSinceSeekBegin = this.state.timeSinceSeekBegin.getDeltaTime();
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {String} att.state Download requires a string to distinguish different states.
     */

  }, {
    key: 'sendDownload',
    value: function sendDownload(att) {
      att = att || {};
      if (!att.state) _log2.default.warn('Called sendDownload without { state: xxxxx }.');
      this.send(VideoTracker.Events.DOWNLOAD, att);
      this.state.goDownload();
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendError',
    value: function sendError(att) {
      att = att || {};
      att.isAd = true;
      this.state.goError();
      var ev = this.isAd() ? VideoTracker.Events.AD_ERROR : VideoTracker.Events.CONTENT_ERROR;
      this.send(ev, att);
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendRenditionChanged',
    value: function sendRenditionChanged(att) {
      att = att || {};
      att.timeSinceLastRenditionChange = this.state.timeSinceLastRenditionChange.getDeltaTime();
      att.shift = this.getRenditionShift(true);
      var ev = void 0;
      if (this.isAd()) {
        ev = VideoTracker.Events.AD_RENDITION_CHANGE;
      } else {
        ev = VideoTracker.Events.CONTENT_RENDITION_CHANGE;
      }
      this.send(ev, att);
      this.state.goRenditionChange();
    }

    /**
     * Sends associated event and changes view state. Heartbeat will automatically be sent every
     * 10 seconds. There's no need to call this manually.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.url Url of the clicked ad.
     *
     */

  }, {
    key: 'sendHeartbeat',
    value: function sendHeartbeat(att) {
      if (this.state.isRequested) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_HEARTBEAT;
        } else {
          ev = VideoTracker.Events.CONTENT_HEARTBEAT;
        }
        this.send(ev, att);
        this.state.goHeartbeat();
      }
    }

    // Only ads
    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendAdBreakStart',
    value: function sendAdBreakStart(att) {
      if (this.isAd() && this.state.goAdBreakStart()) {
        this.send(VideoTracker.Events.AD_BREAK_START, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendAdBreakEnd',
    value: function sendAdBreakEnd(att) {
      if (this.isAd() && this.state.goAdBreakEnd()) {
        att = att || {};
        att.timeSinceAdBreakBegin = this.state.timeSinceAdBreakStart.getDeltaTime();
        this.send(VideoTracker.Events.AD_BREAK_END, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.quartile Number of the quartile.
     */

  }, {
    key: 'sendAdQuartile',
    value: function sendAdQuartile(att) {
      if (this.isAd()) {
        att = att || {};
        if (!att.quartile) _log2.default.warn('Called sendAdQuartile without { quartile: xxxxx }.');
        att.timeSinceLastAdQuartile = this.state.timeSinceLastAdQuartile.getDeltaTime();
        this.send(VideoTracker.Events.AD_QUARTILE, att);
        this.state.goAdQuartile();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.url Url of the clicked ad.
     */

  }, {
    key: 'sendAdClick',
    value: function sendAdClick(att) {
      if (this.isAd()) {
        att = att || {};
        if (!att.url) _log2.default.warn('Called sendAdClick without { url: xxxxx }.');
        this.send(VideoTracker.Events.AD_CLICK, att);
      }
    }
  }]);

  return VideoTracker;
}(_tracker2.default);

/**
 * Enumeration of events fired by this class.
 *
 * @static
 * @memberof VideoTracker
 * @enum
 */


VideoTracker.Events = {
  // Player
  PLAYER_READY: 'PLAYER_READY',
  DOWNLOAD: 'DOWNLOAD',
  ERROR: 'ERROR',

  // Video
  CONTENT_REQUEST: 'CONTENT_REQUEST',
  CONTENT_START: 'CONTENT_START',
  CONTENT_END: 'CONTENT_END',
  CONTENT_PAUSE: 'CONTENT_PAUSE',
  CONTENT_RESUME: 'CONTENT_RESUME',
  CONTENT_SEEK_START: 'CONTENT_SEEK_START',
  CONTENT_SEEK_END: 'CONTENT_SEEK_END',
  CONTENT_BUFFER_START: 'CONTENT_BUFFER_START',
  CONTENT_BUFFER_END: 'CONTENT_BUFFER_END',
  CONTENT_HEARTBEAT: 'CONTENT_HEARTBEAT',
  CONTENT_RENDITION_CHANGE: 'CONTENT_RENDITION_CHANGE',
  CONTENT_ERROR: 'CONTENT_ERROR',

  // Ads only
  AD_REQUEST: 'AD_REQUEST',
  AD_START: 'AD_START',
  AD_END: 'AD_END',
  AD_PAUSE: 'AD_PAUSE',
  AD_RESUME: 'AD_RESUME',
  AD_SEEK_START: 'AD_SEEK_START',
  AD_SEEK_END: 'AD_SEEK_END',
  AD_BUFFER_START: 'AD_BUFFER_START',
  AD_BUFFER_END: 'AD_BUFFER_END',
  AD_HEARTBEAT: 'AD_HEARTBEAT',
  AD_RENDITION_CHANGE: 'AD_RENDITION_CHANGE',
  AD_ERROR: 'AD_ERROR',
  AD_BREAK_START: 'AD_BREAK_START',
  AD_BREAK_END: 'AD_BREAK_END',
  AD_QUARTILE: 'AD_QUARTILE',
  AD_CLICK: 'AD_CLICK'

  // Private members
};function funnelAdEvents(e) {
  this.send(e.type, e.data);
}

exports.default = VideoTracker;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newrelicVideoCore = __webpack_require__(2);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _package = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GooglePublisherTagTracker = function (_nrvideo$Tracker) {
  _inherits(GooglePublisherTagTracker, _nrvideo$Tracker);

  _createClass(GooglePublisherTagTracker, null, [{
    key: 'init',

    /**
     * This static methods initializes the GPT tracker. Will be automatically called.
     * @static
     */
    value: function init() {
      var tracker = new GooglePublisherTagTracker();
      nrvideo.Core.addTracker(tracker);
      tracker.registerListeners();
    }

    /**
     * Constructor
     */

  }]);

  function GooglePublisherTagTracker(options) {
    _classCallCheck(this, GooglePublisherTagTracker);

    var _this = _possibleConstructorReturn(this, (GooglePublisherTagTracker.__proto__ || Object.getPrototypeOf(GooglePublisherTagTracker)).call(this, options));

    _this.slots = {};
    return _this;
  }

  /**
   * Returns tracker name.
   * @returns {String} Tracker name.
   */


  _createClass(GooglePublisherTagTracker, [{
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'google-publisher-tag';
    }

    /**
     * Returns tracker version. Fetched from package.
     * @returns {String} Tracker version.
     */

  }, {
    key: 'getTrackerVersion',
    value: function getTrackerVersion() {
      return _package.version;
    }

    /**
     * Returns given slot info, or creates a new one.
     * @param {string} slotId Unique slot id.
     */

  }, {
    key: 'getSlotState',
    value: function getSlotState(slotId) {
      if (!this.slots[slotId]) {
        // first time
        this.slots[slotId] = {
          chrono: new nrvideo.Chrono(),
          visible: false
        };
      }
      return this.slots[slotId];
    }

    /**
     * Parses slot object to create attributes to send to new relic.
     */

  }, {
    key: 'parseSlotAttributes',
    value: function parseSlotAttributes(slot) {
      var responseInfo = slot.getResponseInformation();
      return {
        name: slot.getName(),
        slotId: slot.getSlotId().getId(),
        advertiserId: responseInfo.advertiserId,
        campaignId: responseInfo.campaignId,
        creativeId: responseInfo.creativeId,
        lineItemId: responseInfo.lineItemId,
        labelIds: responseInfo.labelIds,
        contentUrl: slot.getContentUrl(),
        elementId: slot.getSlotElementId()
      };
    }

    /**
     * Register listeners.
     */

  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      var _this2 = this;

      if (typeof googletag !== 'undefined') {
        googletag.cmd.push(function () {
          var pubads = googletag.pubads();
          pubads.addEventListener('slotRenderEnded', _this2.onSlotRenderEnded.bind(_this2));
          pubads.addEventListener('impressionViewable', _this2.onImpressionViewable.bind(_this2));
          pubads.addEventListener('slotOnload', _this2.onSlotOnload.bind(_this2));
          pubads.addEventListener('slotVisibilityChanged', _this2.onSlotVisibilityChanged.bind(_this2));
        });
      }
    }

    /**
     * Called once GPT fires 'onSlotRenderEnded' event.
     * @param {Event} e
     */

  }, {
    key: 'onSlotRenderEnded',
    value: function onSlotRenderEnded(e) {
      nrvideo.Log.debug('onSlotRenderEnded', e);
    }

    /**
     * Called once GPT fires 'onImpressionViewable' event.
     * @param {Event} e
     */

  }, {
    key: 'onImpressionViewable',
    value: function onImpressionViewable(e) {
      nrvideo.Log.debug('onImpressionViewable', e);
      if (e && e.slot) {
        var id = e.slot.getSlotId().getId();
        var slotState = this.getSlotState(id);

        if (!slotState.visible) {
          var att = this.parseSlotAttributes(e.slot);
          att.serviceName = e.serviceName;

          this.send('SLOT_VISIBLE', att);

          slotState.chrono.start();
          slotState.visible = true;
        }
      }
    }

    /**
     * Called once GPT fires 'onSlotOnload' event.
     * @param {Event} e
     */

  }, {
    key: 'onSlotOnload',
    value: function onSlotOnload(e) {
      nrvideo.Log.debug('onSlotOnload', e);
    }

    /**
     * Called once GPT fires 'onSlotVisibilityChanged' event.
     * @param {Event} e
     */

  }, {
    key: 'onSlotVisibilityChanged',
    value: function onSlotVisibilityChanged(e) {
      nrvideo.Log.debug('onSlotVisibilityChanged', e);
      if (e && e.slot) {
        var id = e.slot.getSlotId().getId();
        var slotState = this.getSlotState(id);
        if (slotState.visible && e.inViewPercentage < 50) {
          var att = this.parseSlotAttributes(e.slot);
          att.serviceName = e.serviceName;
          att.timeVisible = slotState.chrono.getDeltaTime();

          this.send('SLOT_HIDDEN', att);

          slotState.visible = false;
        } else if (!slotState.visible && e.inViewPercentage >= 50) {
          var _att = this.parseSlotAttributes(e.slot);
          _att.serviceName = e.serviceName;

          this.send('SLOT_VISIBLE', _att);

          slotState.chrono.start();
          slotState.visible = true;
        }
      }
    }
  }]);

  return GooglePublisherTagTracker;
}(nrvideo.Tracker);

exports.default = GooglePublisherTagTracker;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {"name":"newrelic-google-publisher-tag","version":"0.1.0","description":"New relic tracker for GPT","main":"src/index.js","scripts":{"build":"webpack -p","build:dev":"webpack","watch":"webpack -p --progress --color --watch","watch:dev":"webpack --progress --color --watch","prezip":"npm run build","zip":"zip -P newrelic -x '*.DS_Store' 'agent.js' '*.map' -r gpt.zip dist samples README.md CHANGELOG.md EULA.md","clean":"rm -rf dist *.zip"},"repository":{"type":"git","url":"git@source.datanerd.us:video/google-publisher-tag-js.git"},"author":"Jordi Aguilar","license":"MIT","dependencies":{"newrelic-video-core":"github:newrelic/video-core-js#v0.10.0"},"devDependencies":{"babel-core":"^6.25.0","babel-loader":"^7.1.1","babel-preset-env":"^1.6.0","videojs-ima":"^0.6.0","webpack":"^3.4.1"}}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// newrelic-google-publisher-tag.min.js